import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { potentialDetail } from '@/api/overseasSales/customerCenter'
import AccountActivationBaseMessage
  from '@/views/overseasSales/customerCenter/accountActivation/components/DetailForm.vue'

const __default__ = { name: 'DcCosOFbuAccountActivationAdd' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute()
const data = ref({})
// 获取详情
const fetch = () => {
  if (route.query.cosId) {
    potentialDetail(route.query.cosId).then((res) => {
      const form: any = {}
      if (res.data.customerInfo) {
        form.cosId = res.data.customerInfo.cosId
        form.customerNumber = res.data.customerInfo.customerNumber
        form.customerName = res.data.customerInfo.customerName
        form.customerWebsite = res.data.customerInfo.customerWebsite
        form.registerEmail = res.data.customerInfo.registerEmail
        form.clientType = res.data.customerInfo.clientType
        form.seller = res.data.customerInfo.seller
        form.remark = res.data.customerInfo.remark
      }
      if (res.data.business) {
        if (res.data.business && res.data.business.businessType && res.data.business.businessType?.length > 0) {
          res.data.business.businessTypeSelect = res.data.business.businessType[0]
        }
        if (!res.data.business.contractInfo) {
          res.data.business.contractInfo = { billingTerm: 3475 }
        } else {
          if (res.data.business.contractInfo.paymentType === 3504 || res.data.business.contractInfo.paymentType === 3473) {
            if (!res.data.business.contractInfo.paymentTerm) {
              res.data.business.contractInfo.paymentTerm = '10'
            }
          }
        }
        if (res.data.business.contractInfo && !res.data.business.contractInfo.billingTerm) {
          res.data.business.contractInfo.billingTerm = 3475
        }
        res.data.business.replenish = undefined
        res.data.business.erpInfo = undefined
        res.data.business.demandInfo = undefined
        res.data.business.saleInfo = undefined
        res.data.visitAddress = undefined
        res.data.business.industrialBeltName = undefined
        form.business = res.data.business
      }
      data.value = form
    })
  }
}
const permissionBasic = {
  save: 'ofbu_potential_edit_btn',
  editCode: 'ofbu_potential_edit_name_or_code_btn'
}
onMounted(() => {
  fetch()
})

return (_ctx: any,_cache: any) => {
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(AccountActivationBaseMessage, {
            disabled: false,
            permissionPage: permissionBasic,
            data: data.value
          }, null, 8, ["data"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})